import { jsx } from "react/jsx-runtime";
import PrintIcon from "@mui/icons-material/Print";
import { validateTidalLicense } from "../../base/index.js";
function Print(props) {
  return /* @__PURE__ */ jsx(
    PrintIcon,
    {
      "data-testid": "Print",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Print",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Print.tidalIconMeta = {
  categories: "fileActions",
  name: "Print"
};
validateTidalLicense();
export {
  Print
};
//# sourceMappingURL=Print.js.map
